<template>
  <v-app>
    <v-main app>
      <router-view></router-view>
    </v-main>
  
    <v-snackbar v-model="snackbar" multi-line>
      {{ error }}
      <template v-slot:actions>
        <v-btn color="blue" variant="text" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ValleFooter from "./components/ValleFooter";

export default {
  components: { ValleFooter },
  name: "App",
  data() {
    return {
      snackbar: false,
    };
  },
  computed: {
    ...mapState(["ocupado", "empresa", "error"]),
  },
  methods: {
    ...mapActions(["cargarEmpresas"]),
  },
  watch: {
    error(v) {
      this.snackbar = v != null;
    },
  },
  mounted() {
    let empresas = localStorage.empresas;
    if (empresas && empresas != "null" && empresas != "") {
      this.cargarEmpresas();
    }
  },
};
</script>

<style scoped>
.v-container {
  min-height: 82vh;
}
</style>
